import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import { Box } from './Box.js';

const { componentTestLabel } = getTestLabels('MessageBox');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Box/MessageBox.tsx)
 *
 * @param {boolean} fullRounded - **DEPRECATED** (optional) This prop is deprecated and has no effect. It will be removed in a later version.
 * @param {string} variant - (optional) One of `success` (default), `danger` or `warning` (deprecated alias to `danger`).
 */
const MessageBox = forwardRef((props, ref) => {
    const { children, variant = 'success', ...otherProps } = props;
    return (jsx(Box, { "data-zta": componentTestLabel, ref: ref, variant: variant, thickBorder: true, ...otherProps, children: children }));
});
MessageBox.displayName = 'MessageBox';

export { MessageBox };
//# sourceMappingURL=MessageBox.js.map
